/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_profileedit_placeholders_displayname2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표시 이름을 입력하세요`)
};

const en_profileedit_placeholders_displayname2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your display name`)
};

const ja_profileedit_placeholders_displayname2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示名を入力してください`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const profileedit_placeholders_displayname2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profileedit_placeholders_displayname2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profileedit_placeholders_displayname2", locale)
	if (locale === "ko") return ko_profileedit_placeholders_displayname2(inputs)
	if (locale === "en") return en_profileedit_placeholders_displayname2(inputs)
	return ja_profileedit_placeholders_displayname2(inputs)
};
export { profileedit_placeholders_displayname2 as "profileEdit_placeholders_displayName" }